import moment from "moment";

export const getTodayHours = (store) => {
  const DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const todayName = DAY_NAMES[new Date().getDay()];
  const hours = (store.business_hours || []).find(
    (h) => (h.day || "").toLowerCase() === todayName.toLowerCase()
  );
  const parseTime = (t) => { const [h, m] = t.split(":").map(Number); return h * 60 + m; };
  if (!hours) return { openMinutes: 6 * 60, closeMinutes: 23 * 60 };
  return {
    openMinutes: parseTime(hours.open_time),
    closeMinutes: parseTime(hours.close_time),
  };
};

export const formatMinutes = (minutes) => {
  const h = Math.floor(minutes / 60).toString().padStart(2, "0");
  const m = (minutes % 60).toString().padStart(2, "0");
  return `${h}:${m}`;
};

export const formatDateTime = (value) => {
  if (!value) return "—";
  return moment.utc(value).local().format("YYYY-MM-DD, h:mm:ss a");
};

export const buildSchedule = (store, rides) => {
  if (!store) return [];
  const todayHours = getTodayHours(store);
  if (!todayHours) return [];
  const { openMinutes, closeMinutes } = todayHours;
  if (closeMinutes <= openMinutes) return [];

  const periodMinutes = ((store.staggering && store.staggering.period_seconds) || 3600) / 60;
  const capacity = (store.staggering && store.staggering.max_orders_per_period) || null;

  const schedule = [];
  for (let start = openMinutes; start < closeMinutes; start += periodMinutes) {
    schedule.push({
      startMinutes: start,
      endMinutes: Math.min(start + periodMinutes, closeMinutes),
      count: 0,
      capacity,
      orderNumbers: [],
    });
  }

  rides.forEach((ride) => {
    const scheduledValue = ride.desired_onsite_datetime;
    if (!scheduledValue) return;
    const scheduledTime = moment.utc(scheduledValue).local();
    if (!scheduledTime.isValid()) return;
    const rideMinutes = scheduledTime.hours() * 60 + scheduledTime.minutes();
    const slotStart = openMinutes + Math.floor((rideMinutes - openMinutes) / periodMinutes) * periodMinutes;
    let slot = schedule.find((s) => s.startMinutes === slotStart);
    if (!slot) {
      slot = { startMinutes: slotStart, endMinutes: slotStart + periodMinutes, count: 0, capacity, orderNumbers: [] };
      schedule.push(slot);
    }
    slot.count += 1;
    if (ride.order_number) slot.orderNumbers.push({ orderNumber: ride.order_number, ride });
  });

  schedule.sort((a, b) => a.startMinutes - b.startMinutes);
  return schedule;
};
